import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import styled from "styled-components";

const Signature = styled.p`
  font-style: italic;
  color: #777;
  margin-top: 1rem;
`;

// Styled Components
const TestimonialContainer = styled.section`
  text-align: center;
  padding: 3rem 1rem;
  background-color: #f8f9fa;
  border-radius: 10px;
  margin-top: 3rem;
`;

const Title = styled.h2`
  font-size: 2rem;
  color: #1a1a1a;
  margin-bottom: 1rem;
  border-bottom: 2px solid black;
  display: inline-block;
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 2rem;
`;

const Carousel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 1rem;
`;

const TestimonialCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 500px;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const CustomerName = styled.h3`
  font-size: 1.5rem;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
`;

const CustomerTestimonial = styled.p`
  font-size: 1rem;
  color: #555;
`;

const ChevronButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 2rem;
  color: #333;
  transition: color 0.3s ease;

  &:hover {
    color: black;
  }
`;


const testimonials = [
    {
      name: "Elara Tech",
      person: "Sophia Reynolds, CEO",
      feedback:
        "Rasynth has been instrumental in automating our customer support using AI. Their deep expertise and tailored solutions have significantly improved our response times.",
    },
    {
      name: "Quantix Analytics",
      person: "Daniel Carter, Head of Data Science",
      feedback:
        "With Rasynth’s AI-driven insights, our data analysis workflows have become 2x faster. Their ability to understand complex problems and provide scalable solutions is impressive.",
    },
    {
      name: "NexaSoft Solutions",
      person: "Ava Mitchell, Co-Founder",
      feedback:
        "We needed an AI-powered recommendation engine for our SaaS product, and Rasynth delivered beyond our expectations. Highly recommended!",
    },
  ];

const TestimonialsSection = () => {
  const [index, setIndex] = useState(0);

  const nextTestimonial = () => {
    setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 4000); // Change testimonial every 3 seconds

    return () => clearInterval(interval);
  }, []);
  
  return (
    <TestimonialContainer>
      {/* <Title>Our Clients</Title> */}
      <Description>
        We’re proud to work with some of the most innovative startups leveraging AI to scale their businesses. Here’s what they have to say about us:
      </Description>

      <Carousel>
        <ChevronButton onClick={prevTestimonial}>
          <ChevronLeft />
        </ChevronButton>

        <motion.div
          key={index}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.5 }}
        >
          <TestimonialCard>
            <CustomerName>{testimonials[index].name}</CustomerName>
            <CustomerTestimonial>{testimonials[index].feedback}</CustomerTestimonial>
            <Signature>— {testimonials[index].person}</Signature>
          </TestimonialCard>
        </motion.div>

        <ChevronButton onClick={nextTestimonial}>
          <ChevronRight />
        </ChevronButton>
      </Carousel>
    </TestimonialContainer>
  );
};


export default TestimonialsSection;

